var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellSmallBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8508",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8508",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEAElEQVR4nO3dTYscVRjF8XMbZhbqIiYq5AXXEgbxbaEJ+QJhQEIEN4MoJCFh/Ai61E+QxYC40o24M3FlVgljgskEURGz14iLKEx3FmYwfxdVI+2tapLp7up6qvv8YBY9U1P3uffUS3fRt0oyMzMbT2q7gL0A9ks6Jum4pNckPSdpv6QD5SL3JP0p6Q9JW5I2JW2mlP6afbVzClgC3gKuAA/Zu4fAN8BpYKnt/nQWkICzwN0xQhjlLnAG6NSRoXXAUeDaFIPIXQWOtt3POuG2FGBV0heSnhixyPeSrqo4P9xRcd64V/7tQPnzgorzzAlJL41Yz31Jb6eUvp5O5XMIeAfYqdmi+8BFYGWMda6U/9uvWe8OsNZEXzoPeB34u2bQLgHPT2H9h4Ava9b/ADgxjT7MDeBp4LeagTrbQFvnavbCX4F9026rs4CPswH6BzjVYHunyzaGfdRUe50CPAsMssH5YAbtfpi1OQCeabrd8ID3soH5hRl8gAOWgTtZ2+823e6j9NouQNLJ7PVGSmmn6UZTSg8kbTyilpn773MIsCzpnKQ1SSuSnmyrqAVxX9KPkj6X9Em5gRSBAIckXZb0cmvlLbbbklZTSr+ncs+4IYfRti1Jb/RUHKYcRvtelXRGwI3sncZX5SHMGgQcprgKMexbUb3Gc7jtYhcFcCQb++0EMLxQSincFeB5lo9/hM8hNsSBBONAgnEgwTiQYBxIMA4kGAcSjAMJxoEE40CCcSDBOJBgHEgwDiQYBxKMAwnGgQTjQIJxIME4kGAcSDAOJBgHEowDCcaBBONAgnEgwTiQYDoTSDlr9v1yPks+jbrOALgOrJezxLoh70Xb9dShuC3G7ccIYZQt4GDb/ahTGf/ogVDsGZOEsesWAW9glhfZhUPWtOZAFnP4oqvZkkJNaWPMOZCMmsMXCNUpbdVDVtmJMKEwwRzImg5vN1nrXpS1Xc4HvzLHMLq9zoHsWv+6cA5ZKA4kmLpArkkazLqQBTRQMdb/VznLBwNsz+NJfVc+/l04ZP2cvd54nFCAI6reD+unqVXVlA7sIet5jRM433Z/cpXx70AgyxTXoib1HR24dBI+EEkCDlJcixrXTXxxcboonpJwAdik/i7VuX657HkC7hm78qJ9N6CW5ePfhXdZC8WBBONAgnEgwTiQYBxIMA4kGAcSjAMJxoEE40CCcSDBOJBgHEgwDiQYBxKMAwnGgQTjQIJxIME4kGB6kvrDvyDQZJ15R/F112H9nsb87qxNhhHfPU7AuqSLLdRkVRd2H716XdIrbVez4G5KOt4rn1K8quJZrNaOW5LeTCntDD++e0nFPO41SS9Keqql4hbFQNIPkj6T9OksniFvZmbz7V9O4a54krasrQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellSmallBusinessIcon);
export default __webpack_public_path__ + "static/media/SellSmallBusinessIcon.0832a5a26542aeffe2fbc586a88de39f.svg";
export { ForwardRef as ReactComponent };